import React, { PropTypes } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Field, getFormValues, reduxForm } from "redux-form";

import { SelectInput } from "../../../common/form";
import { intlShape } from "react-intl";

import * as dataActions from "../../../../utils/data/dataActions";

const formName = "supplierReportsFilter";

class SuppliersReportsFilter extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      fetching: false,
    };

    this.onChange = this.onChange.bind(this);
  }

  onChange(event) {
    const { fields, onChange } = this.props;
    fields[event.target.name] = event.target.value;

    onChange(fields);
  }

  render() {
    const { options } = this.props;

    return (
      <div className="datatable-filter">
        <Field
          id="supplierReportsFilter"
          name="supplierReportsFilter"
          component={SelectInput}
          options={options}
          props={{ onChange: this.onChange }}
          sortOptions={false}
        />
      </div>
    );
  }
}

SuppliersReportsFilter.propTypes = {
  change: PropTypes.func.isRequired,
  dataActions: PropTypes.object,
  fields: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
};

SuppliersReportsFilter.contextTypes = {
  intl: intlShape,
};

function mapStateToProps(state) {
  return {
    fields: getFormValues(formName)(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dataActions: bindActionCreators(dataActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: formName,
  })(SuppliersReportsFilter)
);



// WEBPACK FOOTER //
// ./src/components/dashboard/importExport/suppliersReports/SuppliersReportsFilter.js